import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import { Col, Overlay, Popover, Input } from 'bootstrap';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';

const defaultPopoverId = 'inputColorPicker';

export default React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility')],

  displayName: 'SimpleInputColorPicker',

  propTypes: {
    activeHexColor: React.PropTypes.string,
    popoverId: React.PropTypes.string,
    onChange: React.PropTypes.func,
    placement: React.PropTypes.string,
    label: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
    };
  },

  render() {
    const { activeHexColor, label, onChange } = this.props;

    return (
      <div className="simple-input-color-picker-wrapper">
        <Input
          ref="target"
          label={label}
          placeholder="Type a hex"
          type="text"
          value={activeHexColor}
          onClick={() => PopoverActions.show(this._getPopoverId())}
          onChange={(e) => onChange(e.target.value)}
        />
        <Overlay
          rootClose
          show={this.state.popoverVisibility.get(this._getPopoverId())}
          onHide={this._handleHide}
          placement={this.props.placement}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          {this._getPopoverNode()}
        </Overlay>
      </div>
    );
  },

  _getPopoverNode() {
    let colorNodes = this.props.defaultHexColors.map((hexColor, i) => {
      return this._getColorSquareNode(hexColor, i);
    });

    return (
      <Popover className="simple-input-color-popover">
        <Col>
          <p>Or, choose from default colors</p>
        </Col>
        <Col>
          <div className="simple-input-color-node-wrapper">{colorNodes}</div>
        </Col>
      </Popover>
    );
  },

  _handleHide() {
    PopoverActions.hide(this._getPopoverId());
  },

  _getColorSquareNode(hexColor, index) {
    return (
      <div
        className="simple-input-color-node"
        key={index}
        style={{ background: hexColor, border: `1px solid ${hexColor}` }}
        name="square"
        onClick={() => this._handleOnClick(hexColor)}
      />
    );
  },

  _handleOnClick(hexColor) {
    this.props.onChange(hexColor);
    PopoverActions.hide(this._getPopoverId());
  },

  _getPopoverId() {
    return this.props.popoverId || defaultPopoverId;
  },
});
